import { create } from 'zustand';
import Issue from '@/types/issueType';
import { IssueReqOrg, IssueReqInd } from '@/types/issueReqType';
import {
  fetchIssuesForIndividual,
  fetchIssuesForLoggedOutUser,
  fetchIssuesForOrg,
} from '@/apis/fetchIssuesForUser';
import headerObject from '@/types/headerObj';
import emptyHeaderObj from '@/types/emptyHeaderObj';
import useUserStore from './userState';
import useOrganizationStore from './orgState';

interface IssueState {
  issueList: Issue[];
  setIssueListOrg: (req: IssueReqOrg) => Promise<Issue[]>;
  setIssueListInd: (req: IssueReqInd) => Promise<Issue[]>;
  setIssueListForLoggedOut: (reponame: string) => Promise<Issue[]>;
}
const headerObj: headerObject = emptyHeaderObj;
headerObj.Useruuid = useUserStore.getState().user?.UserUUID;
headerObj.Useremail = useUserStore.getState().user?.Email;
headerObj.Username = useUserStore.getState().user?.FirstName;
headerObj.Orgname = useOrganizationStore.getState().organization?.OrgName;
headerObj.Orguuid = useOrganizationStore.getState().organization?.OrgUUID;
const useIssueStore = create<IssueState>()((set, get) => ({
  issueList: [],

  setIssueListOrg: async (req: IssueReqOrg) => {
    const issueList = await fetchIssuesForOrg(req, headerObj);
    set({
      issueList: issueList || [],
    });
    return issueList || [];
  },

  setIssueListInd: async (req: IssueReqInd) => {
    const issueList = await fetchIssuesForIndividual(req, headerObj);

    set({
      issueList: issueList || [],
    });
    return issueList || [];
  },
  setIssueListForLoggedOut: async (reponame: string) => {
    const issueList = await fetchIssuesForLoggedOutUser(reponame);
    set({
      issueList: issueList || [],
    });
    return issueList || [];
  },
}));

export default useIssueStore;
